/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {useThemeMode} from '../theme/useThemeContext';
import {FilterTreeNodeIconView} from './FilterTreeNodeIconView';

export interface FilterTreeNodeIconProps {
  isAsset: boolean;
}

/**
 * Renders the icon shared by tree checklist node rows and search result
 * rows - an asset icon when `isAsset`, otherwise a group icon.
 *
 * ```typescript
 * import FilterTreeNodeIcon from '@ion/dls/src/filters/FilterTreeNodeIcon';
 *
 * ...
 *
 * <FilterTreeNodeIcon isAsset={node.type === 'asset'} />
 * ```
 */
export const FilterTreeNodeIcon = ({isAsset}: FilterTreeNodeIconProps) => {
  // re-renders on a theme mode change so the color re-resolves ...
  useThemeMode();
  return <FilterTreeNodeIconView isAsset={isAsset} />;
};

export default FilterTreeNodeIcon;
